module.exports = __webpack_public_path__ + "media/brands/andoria-af035e59.png";